
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { nativeType, useDrop } from "../../../Bindings/Fable.ReactDnD.js";
import { tryFind, item, equalsWith } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { int32ToString, createObj, defaultOf, equals } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { TextValue } from "../../../Components/Text.js";
import { isEmpty, singleton as singleton_1, map, empty as empty_1, toArray, filter, length, ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Button, TextButton } from "../../../Components/Button.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../../Widgets/Table/Types.js";
import { hasValueChanged, tryGetFieldValueByName } from "./Common.js";
import { ValidationRowModal } from "./ValidationRowModal.js";
import { unwrap, defaultArg } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { RowValidation } from "../../../Shared/Updater.js";
import { InfiniteTable } from "../../../Widgets/Table/InfiniteTable.js";
import { SectionContainer } from "../../../Widgets/Container.js";
import { ErrorAlert, InformationAlert } from "../../../Components/Alert.js";
import { FormState__getValidation } from "../../../Shared/Shared.js";

export function UploadArea(props) {
    let elems_3, elems, elems_2, elems_1;
    const patternInput = useTranslation();
    const validateFile = (file) => {
        const formData = new FormData();
        formData.append(file.name, file);
        props.ValidateFormData(formData);
    };
    const patternInput_1 = useDrop({
        accept: nativeType.FILE,
        collect: (monitor) => {
            const isOver = monitor.isOver();
            return {
                canDrop: monitor.canDrop(),
                isOver: isOver,
            };
        },
        drop: (draggedFile) => {
            let testExpr, testExpr_1;
            const matchValue = draggedFile.files;
            if (props.ComponentState === "disabled") {
            }
            else if (matchValue == null) {
            }
            else if ((testExpr = matchValue, !equalsWith(equals, testExpr, defaultOf()) && (testExpr.length === 0))) {
            }
            else if ((testExpr_1 = matchValue, !equalsWith(equals, testExpr_1, defaultOf()) && (testExpr_1.length === 1))) {
                const file_1 = item(0, matchValue);
                validateFile(file_1);
            }
        },
    });
    const dropData = patternInput_1[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems = [createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: "Upload",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("border"), delay(() => append(singleton("rounded"), delay(() => append(singleton("border-dashed"), delay(() => append(singleton("border-primary"), delay(() => append(singleton("p-4"), delay(() => ((dropData.isOver && dropData.canDrop) ? singleton("bg-background") : empty()))))))))))))))], ["ref", patternInput_1[1]], (elems_2 = [createElement(TextButton, {
        ComponentState: props.ComponentState,
        Label: patternInput[0]("file_upload.select_file"),
        OnClick: () => {
            const element = document.getElementById("file-upload");
            element.click();
        },
        TestId: "open-file-explorer-test-id",
        Variant: "blueButton",
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "justify-center"])], (elems_1 = [reactElement("input", {
        id: "file-upload",
        className: join(" ", ["hidden"]),
        type: "file",
        accept: ".xls, .xlsx",
        disabled: props.ComponentState === "disabled",
        onChange: (ev) => {
            const files = ev.target.files;
            if (!(files == null) && (files.length > 0)) {
                validateFile(files.item(0));
            }
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function rowValidationColumns(t) {
    return [new ColumnDefinition$1("Name", "", t("updater.validation_table.name"), (rv) => (new CellContent(0, [t(rv.Name)])), "text", "text"), new ColumnDefinition$1("InventoryNumber", "", t("updater.validation_table.inventory_number"), (rv_1) => (new CellContent(0, [tryGetFieldValueByName(t, "InventoryNumber", rv_1)])), "text", "text"), new ColumnDefinition$1("Id", "", t("updater.validation_table.id"), (rv_2) => (new CellContent(0, [rv_2.ToolId])), "text", "text"), new ColumnDefinition$1("IsRowValid", "", t("updater.validation_table.row_status"), (rv_3) => (rv_3.IsRowValid ? (new CellContent(0, [t("updater.validation_table.valid")])) : (new CellContent(0, [t("updater.validation_table.invalid")]))), "select", "text"), new ColumnDefinition$1("ChangeCount", "", t("updater.validation_table.change_count"), (rv_4) => (new CellContent(0, [int32ToString(length(filter((f) => {
        if (f.IsValid) {
            return hasValueChanged(t, f);
        }
        else {
            return false;
        }
    }, rv_4.Fields)))])), "text", "text"), new ColumnDefinition$1("ErrorCount", "", t("updater.validation_table.error_count"), (rv_5) => (new CellContent(0, [int32ToString(length(filter((f_1) => !f_1.IsValid, rv_5.Fields)))])), "text", "text")];
}

function ImportValidationView(props) {
    let elems;
    const t = useTranslation()[0];
    let rowsArray;
    const dependencies_1 = [props.Rows];
    rowsArray = reactApi.useMemo(() => toArray(props.Rows), dependencies_1);
    let rowColumns;
    const dependencies_1_1 = [t];
    rowColumns = reactApi.useMemo(() => rowValidationColumns(t), dependencies_1_1);
    const patternInput_1 = reactApi.useState(undefined);
    const setSelectedId = patternInput_1[1];
    const selectedId = patternInput_1[0];
    let selectedRow;
    const dependencies_1_2 = [selectedId, rowsArray];
    selectedRow = reactApi.useMemo(() => {
        if (selectedId != null) {
            const id = selectedId;
            return tryFind((rv) => (rv.ToolId === id), rowsArray);
        }
        else {
            return undefined;
        }
    }, dependencies_1_2);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems = [createElement(ValidationRowModal, {
        IsOpen: selectedRow != null,
        OnClose: () => {
            setSelectedId(undefined);
        },
        RowValidation: defaultArg(selectedRow, new RowValidation("", "", empty_1(), false)),
    }), createElement(InfiniteTable, {
        ColumnDefinitions: rowColumns,
        Controls: empty_1(),
        Options: {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["ErrorCount", "desc"],
            Fullscreen: false,
            GlobalSearch: false,
            OnRowClick: new OnTableRowClick$1(0, [(rv_1) => {
                if (equals(rv_1.ToolId, selectedId)) {
                    setSelectedId(undefined);
                }
                else {
                    setSelectedId(rv_1.ToolId);
                }
            }]),
            RowSelection: "disabled",
            SaveTableConfiguration: true,
            WithQueryParameters: false,
        },
        TableKey: "updater-import-validation-overview",
        TableRows: rowsArray,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function InfoArea(props) {
    let elems_8, elems_7, elems_6;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems_8 = [reactElement("div", createObj(ofArray([["className", join(" ", ["p-4", "space-y-3"])], (elems_7 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "md:grid-cols-2", "gap-4"])], (elems_6 = toList(delay(() => {
        let elems_2, elems_1;
        return append(singleton(reactElement("div", createObj(singleton_1((elems_2 = [createElement(TextValue, {
            FontWeight: "bold",
            TestId: "",
            Text: t("updater.update_rules.will_be_updated_title"),
        }), reactElement("ul", createObj(ofArray([["className", join(" ", ["list-disc", "pl-5", "mt-2", "space-y-1"])], (elems_1 = toList(delay(() => map((updatedField) => {
            let elems;
            const children = singleton_1(reactElement("span", createObj(singleton_1((elems = toList(delay(() => ((updatedField.Description !== "") ? append(singleton(reactElement("span", {
                children: t(updatedField.Name) + ": ",
            })), delay(() => singleton(reactElement("span", {
                children: updatedField.Description,
            })))) : singleton(reactElement("span", {
                children: t(updatedField.Name),
            }))))), ["children", reactApi.Children.toArray(Array.from(elems))])))));
            return reactElement("li", {
                children: reactApi.Children.toArray(Array.from(children)),
            });
        }, props.UpdatedFields))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))]))))), delay(() => {
            let elems_5, elems_4;
            return !isEmpty(props.NotUpdatedFields) ? singleton(reactElement("div", createObj(singleton_1((elems_5 = [createElement(TextValue, {
                FontWeight: "bold",
                TestId: "",
                Text: t("updater.update_rules.will_not_be_updated_title"),
            }), reactElement("ul", createObj(ofArray([["className", join(" ", ["list-disc", "pl-5", "mt-2", "space-y-1"])], (elems_4 = toList(delay(() => map((updatedField_1) => {
                let elems_3;
                const children_2 = singleton_1(reactElement("span", createObj(singleton_1((elems_3 = toList(delay(() => ((updatedField_1.Description !== "") ? append(singleton(reactElement("span", {
                    children: t(updatedField_1.Name) + ": ",
                })), delay(() => singleton(reactElement("span", {
                    children: updatedField_1.Description,
                })))) : singleton(reactElement("span", {
                    children: t(updatedField_1.Name),
                }))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])))));
                return reactElement("li", {
                    children: reactApi.Children.toArray(Array.from(children_2)),
                });
            }, props.NotUpdatedFields))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))]))))) : empty();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
}

export function UpdaterWidget(props) {
    let elems_4;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems_4 = toList(delay(() => {
        let Title, elems_1, elems;
        return append(singleton(createElement(SectionContainer, (Title = t(props.Title), {
            Content: reactElement("div", createObj(singleton_1((elems_1 = [createElement(InformationAlert, {
                Label: "updater.information_text",
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-8"])], (elems = [createElement(InfoArea, {
                NotUpdatedFields: props.NotUpdatedFields,
                UpdatedFields: props.UpdatedFields,
            }), createElement(UploadArea, {
                ComponentState: componentState,
                ValidateFormData: props.OnUploadFile,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])))),
            Title: unwrap(Title),
        }))), delay(() => {
            let elems_2, Label;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "my-5"])], (elems_2 = [createElement(Button, (Label = t("general.upload"), {
                ComponentState: (componentState === "enabled") ? (isEmpty(props.Rows) ? "disabled" : componentState) : componentState,
                Label: Label,
                OnClick: props.OnUploadData,
                TestId: "updater-upload-button",
                Variant: "primary",
            }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                let matchValue, globalValidationMessage, elems_3;
                return append((matchValue = FormState__getValidation(props.FormState, t, "global"), (matchValue == null) ? (empty()) : ((globalValidationMessage = matchValue, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_3 = [createElement(ErrorAlert, {
                    Label: globalValidationMessage,
                })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))))))), delay(() => singleton(createElement(ImportValidationView, {
                    Rows: props.Rows,
                }))));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

